
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import TabPage from "../../factories/tab-page";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";

/*
 * ViewModel for the ShiftGroup tab in the ShiftPlanModel view
 * */
class ShiftPlanModelShiftGroupTab extends GenericListTab {

    Bao = Bao;
    SelectedGroupId = ko.observable();
    SelectedGroup = ko.observable();

    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);

        this.Models.subscribe(() => {
            this.Selection([]);
        });

        this.SelectedGroup.subscribe(() => {
            this.AddShiftGroup();
        });

        Bao.bindEvent('shiftplanmodelshiftgroup:refresh', (params) => {
            this.RefreshItem(params.id);
        });
    }

    /*
     * Overridden basic function to support custom filters
     * */
    CustomFilter() {
        let customFilter = [];
        customFilter.push({ key: 'ShiftPlanModelId', value: this.GetParentId() });
        return customFilter;
    }

    /*
     * Overridden basic Get Url
     * */
    UrlGet(): string {
        return this.ControllerUrl + "/GetAllByShiftPlanModelId";
    }

    /*
    * Overridden basic Init Url
    * */
    UrlInit(): string {
        return this.ControllerUrl + "/InitShiftGroupList";
    }

    ItemCompleteCheck(item): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }

    /*
     * Overridden default dialog behavior. The record opens in a new tab
     * */
    Dialog(id: string): JQueryPromise<any> {
        var def = $.Deferred<boolean>();

        if (id) {
            this.GoToShiftGroup(id);
        }
        else {
            this.ShowGroupDialog();
        }

        def.resolve(true);
        return def.promise();
    }

    /*
     * A function that opens a ShiftGroup in a new tab
     * */
    GoToShiftGroup(id: string) {
        let url = "#shiftgroup/" + id + '/' + this.GetParentId();
        baoRouter.setHash(url);
    }

    Save(item: Models.BaseModel2): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise();
    }

    ShowGroupDialog = function () { };

    /*
     * Add a shift group to shift pattern
     * */
    AddShiftGroup () {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftPlanModelShiftGroupTab/AddShiftGroup", JSON.stringify({
            sessionTabId: this.SessionTabId,
            shiftPlanModelId: this.GetParentId(),
            groupId: this.SelectedGroupId()
        })).then(() => {
            return this.Get();
        }).then(() => this.TabPage.DirtyFlag(true))
        .always(() => this.TabPage.IsLoading(false));
    }

    /*
     * Refreshes an item in a session after group changes
     * */
    RefreshItem(id) {
        const dirty = this.TabPage.IsDirty();
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftPlanModelShiftGroupTab/RefreshItem", JSON.stringify({
            sessionTabId: this.SessionTabId,
            shiftPlanModelId: this.GetParentId(),
            groupId: id
        })).then((res) => {
               return this.Get()
                    .then(() => this.TabPage.DirtyFlag(dirty));
        }).always(() => this.TabPage.IsLoading(false));
    }

    CustomToolbarClick(button: Interfaces.Bao.BaoMenuItem) {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case 'ShiftPlanModelShiftGroupTabNewGroup':
                this.GoToShiftGroup(null);
                break;
        }
    }
}
export default ShiftPlanModelShiftGroupTab;